import React from 'react';
import { useSettingsStore } from '../../stores/settingsStore';

const svgBase = { fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round', viewBox: '0 0 24 24' };

// The padlock in the header's top-right corner. It carries data-lock-allow so
// it stays clickable while locked — it is the only way back out.
export default function EditLockButton() {
  const locked = useSettingsStore(s => s.editLock);
  const toggle = useSettingsStore(s => s.toggleEditLock);

  return (
    <button
      data-lock-allow
      onClick={toggle}
      aria-pressed={locked}
      title={locked
        ? 'Locked — only TAKE, SKIP and BACK work. Click to unlock.'
        : 'Lock: block every click, drag and edit except TAKE, SKIP and BACK'}
      style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center', width: 30, height: 30, borderRadius: 6,
        color: locked ? 'var(--next)' : 'var(--faint)',
        background: locked ? 'color-mix(in srgb, var(--next) 14%, transparent)' : 'transparent',
        border: `1px solid ${locked ? 'var(--next)' : 'transparent'}`,
        cursor: 'pointer', flexShrink: 0, padding: 0,
      }}
    >
      <svg {...svgBase} width={16} height={16}>
        <rect x="5" y="11" width="14" height="10" rx="2" />
        {/* Shackle closed when locked, swung open when not. */}
        <path d={locked ? 'M8 11V7a4 4 0 0 1 8 0v4' : 'M8 11V7a4 4 0 0 1 7.75-1.4'} />
      </svg>
    </button>
  );
}
